import { useRef } from "react";
import { TABLE_TOP_CORNERS, useGridHeaderCorners } from "../../../v2/components/tableHeaderCorners.js";
// List view: Dates (selected zone; all-day = destination dates), Trip, Where, Who, Project.
import { T } from "../../../app/tokens.js";
import { tx } from "./travelStyles.js";
import { sortTrips, tripDateRange, travelerSummary, purposeStyle, purposeLabel, zoneAbbr } from "./travelModel.js";

const COLS = "minmax(150px,1.1fr) minmax(200px,2fr) minmax(150px,1.3fr) minmax(140px,1.2fr) minmax(130px,1fr)";

export function TravelList({ trips, zone, showNames, holidayTripIds, onOpenTrip, onOpenProject }) {
  const headerRef = useRef(null);
  const viewportRef = useRef(null);
  useGridHeaderCorners(headerRef, viewportRef);
  const rows = sortTrips(trips);
  return (
    <div ref={viewportRef} data-testid="travel-list" style={{ ...tx.card, ...TABLE_TOP_CORNERS, overflow: "auto" }}>
      <div role="table" aria-label="Trips" style={{ minWidth: 820 }}>
        <div ref={headerRef} role="row" style={{ ...TABLE_TOP_CORNERS, display: "grid", gridTemplateColumns: COLS, padding: "0 16px", height: 32, alignItems: "center", background: T.travelDowBg, ...tx.eyebrow, gap: 10 }}>
          <div role="columnheader">Dates ({zoneAbbr(zone)})</div><div role="columnheader">Trip</div><div role="columnheader">Where</div><div role="columnheader">Who</div><div role="columnheader">Project</div>
        </div>
        {rows.map((trip) => {
          const tone = purposeStyle(trip.purposeType);
          return (
            <div role="row" key={trip.id} data-testid={`travel-row-${trip.id}`} style={{ display: "grid", gridTemplateColumns: COLS, gap: 10, padding: "8px 16px", minHeight: 40, alignItems: "center", borderTop: `1px solid ${T.travelHair}`, fontSize: T.fsSm, color: T.dark }}>
              <div role="cell" style={{ fontVariantNumeric: "tabular-nums" }}>{tripDateRange(trip, zone)}</div>
              <div role="cell" style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: 3, background: tone.bg, border: `1px solid ${tone.fg}`, flexShrink: 0 }} />
                <button type="button" data-testid={`travel-row-open-${trip.id}`} onClick={() => onOpenTrip(trip.id)} style={{ ...tx.link, color: T.dark, fontWeight: T.fwBold, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={purposeLabel(trip.purposeType)}>{trip.title}</button>
                {holidayTripIds.has(trip.id) && <span title="Overlaps a non-working day at the destination" style={{ color: T.travelAmberFg, fontWeight: T.fwBlack }}>⚑</span>}
              </div>
              <div role="cell" style={{ minWidth: 0 }}><span style={{ ...tx.flag, marginRight: 6 }}>{trip.destinationCountry}</span>{trip.destinationLabel}</div>
              <div role="cell" style={{ color: trip.travelerCount ? T.dark : T.mid }}>{travelerSummary(trip, showNames)}</div>
              <div role="cell">{trip.projectId
                ? <button type="button" data-testid={`travel-row-project-${trip.id}`} style={tx.link} onClick={() => onOpenProject(trip.projectId)}>{trip.projectName || "Project"}</button>
                : <span style={{ color: T.mid }}>—</span>}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
